import { getReq } from '../service/API'
import useSWR from 'swr'
import { getProjectSettings_endpoint, getProject_endpoint } from '../service/api-gateway'

export const useProject = (projectId: string) => {
  const endpoint = projectId ? getProject_endpoint(projectId) : null
  const { data, error } = useSWR(endpoint, getReq, { suspense: true })

  return {
    data: !data ? null : data.data,
    isLoading: !error && !data,
    isError: error,
  }
}

export const useProjectAndPopulate = (projectId: string) => {
  const endpoint = projectId ? getProjectSettings_endpoint(projectId) : null
  const { data, error } = useSWR(endpoint, getReq, { suspense: true })

  return {
    data: !data ? null : data.data,
    isLoading: !error && !data,
    isError: error,
  }
}
